import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M147.4 22.2c.2 1 .8 1.3 1.8 1l18.6-.6c16.4 0 29.2 14.3 30.1 31.7l.1 1.9v127h-20.1v-127c0-7.3-4.3-12.7-9.1-13.4l-1-.1-18.6.6v125.4c0 16.1-12.7 29.2-28.3 29.2-1.5 0-3-.1-4.5-.4l-1.5-.3-90.6-10.3c-12.6-2.8-21.7-14-22.4-27.2V41.8c0-13.3 8.7-24.9 21.1-28.3l1.3-.3L115 2.9c15.3-3.3 29.1 3.5 32.4 19.3zm-41.7 58.9c-2.7 0-5.2 1.1-7.1 3s-2.9 4.5-2.9 7.1v20.2c0 2.7 1.1 5.2 2.9 7.1 1.9 1.9 4.4 3 7.1 3 2.7 0 5.2-1.1 7.1-3s2.9-4.5 2.9-7.1V91.2c0-2.7-1.1-5.2-2.9-7.1-1.8-2-4.4-3-7.1-3z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}